import React from 'react'
import BEMHelper from 'react-bem-helper'

import Contact from '../../components/Contact'
import List from '../../components/List'
import Preview from '../../components/Preview'
import { Grid, Col } from '../../components/Grid'

import clooger1 from '../../images/cases/clooger-1.jpg'
import clooger2 from '../../images/cases/clooger-2.jpg'
import clooger3 from '../../images/cases/clooger-3.jpg'
import clooger4 from '../../images/cases/clooger-4.jpg'

import './index.css'
import cases from '../../data/cases'
import Helmet from '../../components/seo/Helmet'

const classes = new BEMHelper('clooger')

export default function Clooger ({ helmetProps }) {
  const info = cases.find(({ slug }) => slug === 'clooger')
  const { name, preamble, description } = info

  const images = [
    { src: clooger1, caption: 'Kart' },
    { src: clooger2, caption: 'Detaljert kart' },
    { src: clooger3, caption: 'Nær deg' },
    { src: clooger4, caption: 'Dine skatter' }
  ]

  return (
    <article>
      <Helmet {...helmetProps} />
      <h1 {...classes('title')}>{name}</h1>

      <Grid>
        <Col>
          <p>
            <em>{preamble}</em>
          </p>

          <p dangerouslySetInnerHTML={{ __html: description.props.children }} />
        </Col>
        <Col>
          <p>
            For Clooger har Appresso laget serverprogramvaren og en mobilapp
            som gjør det mulig for bedrifter å legge ut virtuelle skatter. Hvis
            en person som har appen på sin mobil nærmer seg en skatt vil en
            melding om dette komme på telefonen, og jakten kan begynne.
            Annonsører kan registrere seg og selv legge ut skatter i områdene de
            ønsker. Ved å legge ut premier, gavekort, rabattkort, kan de på en
            ny og spennende måte få kundene til sin butikk.
          </p>

          <p>
            Clooger er blant annet kjent fra radiokanalen P4 sine skattejakter rundt i Norge.
            Appresso har laget en embed-løsning som gjør at Clooger
            også finnes tilgjengelig inne i P4-appen.
          </p>

          <p>
            Teknisk byr Clooger på mange interessante utfordringer. Det må tas
            hensyn for perioder med stor trafikk på serverne, og det må gjøres
            mange interessante beregninger for lokasjon og bevegelser mens
            skattejakten pågår. Back-end applikasjonen til Clooger er bygget med
            Django, som database benyttes PostgreSQL, og den kjører på Heroku.
          </p>

          <List>
            <li>
              <a
                href="http://www.clooger.biz/"
                target="_blank"
                rel="noopener noreferrer"
              >
                Clooger
              </a>
            </li>
          </List>
        </Col>
      </Grid>

      <Preview slides={images} />

      <Contact
        who="tor"
        title="Noe du lurer på?"
      >
        Ta kontakt med <strong>Tor Ivar</strong> om du har spørsmål om hva
        Appresso kan levere.
      </Contact>
    </article>
  )
}



// WEBPACK FOOTER //
// ./src/pages/Clooger/index.js